import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const process = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;

      if (!sessionId) {
        navigate("/login");
        return;
      }

      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data);
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { state: { user: res.data } });
      } catch {
        navigate("/login?error=auth");
      }
    };

    process();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F6F3EC]">
      <div className="text-center">
        <div className="h-8 w-8 border-2 border-[#0A0A0A] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-sm text-[#525252]">Signing you in…</p>
      </div>
    </div>
  );
}
